export default __webpack_public_path__ + "static/media/icon-mock.a41c90d4.svg";